if (!customElements.get('noire-scent-modal')) {
  customElements.define('noire-scent-modal', class extends HTMLElement {
    connectedCallback() {
      this.scope = this.closest('product-info') || this.closest('.shopify-section');
      this.dialog = this.querySelector('dialog');
      if (!this.scope || !this.dialog) return;
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.scope.addEventListener('click', (event) => {
        const picker = event.target.closest('variant-selects');
        if (!picker) return;
        const label = event.target.closest('label[for]');
        const input = label ? document.getElementById(label.htmlFor) : event.target.closest('input[type="radio"]');
        if (!input || !picker.contains(input)) return;
        const value = input.value;
        window.clearTimeout(this.openTimer);
        this.openTimer = window.setTimeout(() => this.openScent(value), 0);
      }, options);
      this.scope.addEventListener('change', (event) => {
        if (event.target.matches('variant-selects select, variant-selects input[type="radio"]')) {
          this.openScent(event.target.value);
        }
      }, options);
      this.querySelector('.nsm-close').addEventListener('click', () => this.dialog.close(), options);
      this.dialog.addEventListener('click', (event) => {
        if (event.target !== this.dialog) return;
        const rect = this.dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.dialog.close();
      }, options);
      this.dialog.addEventListener('close', () => {
        document.documentElement.style.overflow = this.previousOverflow ?? '';
        const input = [...this.scope.querySelectorAll('variant-selects input, variant-selects select')]
          .find((element) => element.value === this.currentValue);
        input?.focus({ preventScroll: true });
      }, options);
      const svg = this.querySelector('svg');
      this.angle = .5;
      this.drawPyramid();
      let dragging = false, x = 0;
      svg.addEventListener('pointerdown', (event) => {
        dragging = true; x = event.clientX; svg.setPointerCapture(event.pointerId);
      }, options);
      svg.addEventListener('pointermove', (event) => {
        if (!dragging) return;
        this.angle += (event.clientX - x) * .012;
        x = event.clientX; this.drawPyramid();
      }, options);
      for (const name of ['pointerup', 'pointercancel', 'lostpointercapture']) svg.addEventListener(name, () => { dragging = false; }, options);
    }
    disconnectedCallback() {
      window.clearTimeout(this.openTimer);
      if (this.dialog?.open) {
        document.documentElement.style.overflow = this.previousOverflow ?? '';
        this.dialog.close();
      }
      this.abort?.abort();
    }
    openScent(value) {
      const key = { 'limone sul garda': 'limone', 'royal oud': 'oud', 'seta': 'seta' }[String(value).trim().toLowerCase()];
      const template = key && this.querySelector('template[data-scent="' + key + '"]');
      if (!template || !this.isConnected) return;
      this.currentValue = value;
      this.querySelector('.nsm-title').textContent = template.dataset.title;
      this.querySelector('.nsm-summary').textContent = template.dataset.summary;
      this.querySelector('.nsm-notes').replaceChildren(template.content.cloneNode(true));
      if (!this.dialog.open) {
        this.previousOverflow = document.documentElement.style.overflow;
        this.dialog.showModal();
        document.documentElement.style.overflow = 'hidden';
      }
    }
    drawPyramid() {
      const svg = this.querySelector('svg'), ns = 'http://www.w3.org/2000/svg';
      const rotate = ([x,y,z]) => {
        const a = this.angle, b = -.3;
        const xx=x*Math.cos(a)+z*Math.sin(a), zz=-x*Math.sin(a)+z*Math.cos(a);
        return [xx,y*Math.cos(b)-zz*Math.sin(b),y*Math.sin(b)+zz*Math.cos(b)];
      };
      const project = ([x,y,z]) => { const s=900/(900-z); return [160+x*s,185+y*s]; };
      const faces=[];
      for(const [h,y0,y1] of [[50,-100,-58],[78,-25,17],[105,50,92]]) {
        const points=[[-h,y0,-h],[h,y0,-h],[h,y0,h],[-h,y0,h],[-h,y1,-h],[h,y1,-h],[h,y1,h],[-h,y1,h]].map(rotate);
        for(const [i,indices] of [[0,[0,1,2,3]],[1,[4,5,6,7]],[2,[3,2,6,7]],[3,[1,0,4,5]],[4,[2,1,5,6]],[5,[0,3,7,4]]]) {
          const corners=indices.map(j=>points[j]);
          faces.push({z:corners.reduce((s,p)=>s+p[2],0)/4,points:corners.map(project).map(p=>p.join(',')).join(' '),fill:i===0?'#efe3c5':i%2?'#d6c29c':'#e3d1ad'});
        }
      }
      const nodes=[];
      const shadow=document.createElementNS(ns,'ellipse');
      for(const [key,value] of Object.entries({cx:160,cy:335,rx:113,ry:12,fill:'#18161320'})) shadow.setAttribute(key,value);
      nodes.push(shadow);
      for(const face of faces.sort((a,b)=>a.z-b.z)) {
        const polygon=document.createElementNS(ns,'polygon');
        for(const [key,value] of Object.entries({points:face.points,fill:face.fill,stroke:'#9c8458','stroke-width':1.2,'stroke-linejoin':'round'})) polygon.setAttribute(key,value);
        nodes.push(polygon);
      }
      svg.replaceChildren(...nodes);
    }
  });
}
